import {
  Button,
  Checkbox,
  Chip,
  Stack,
  Tab,
  Tabs,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { FormControl, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Box } from "@mui/system";
import { checkNumber, checkSpecialChar } from "../utilities/FormValidation";
import _ from "lodash";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";


const TerritoriesForm = () => {
  const [personName, setPersonName] = useState([]);
  const [users, setUsers] = useState([]);
  const [partner, setPartner] = useState([]);
  const [partnerId, setPartnerId] = useState([]);
  const [error, setError] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [territoryId, setTerritoryId] = useState();
  const [territoryName, setTerritoryName] = useState("");
  const [validError, setValidError] = useState({});
  const [checksubmit, setCheckSubmit] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [editData, setEditData] = useState();
  const [deSelectedPartner, setDeSelectedPartner] = useState([]);
  const [hideDelete, setHideDelete] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);
  const [checked, setChecked] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentEmail, setCurrentEmail] = useState();
  const [allUserList, setAllUserList] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const leftChecked = checked.filter((value) => companyList.includes(value));
  const rightChecked = checked.filter((value) => partner.includes(value));
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territory}`;
  const baseUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
  const companyURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}`;
  const userURL = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}?size=1000`;
  const [inputValue, setInputValue] = useState("");

  const findUsers = async () => {
    const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}/listUsers`;

    const list = await OAuthService.getList(
      url + `?sort=userId,desc&size=1000`
    );
    let users = list.data;
    const roleurl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.role}`;
    let usersRole = [];
    users.map((data) => {
      data?.roles?.map((role) => {
        usersRole = [...usersRole, role];
      });
    });
    let rolesArray = [];
    usersRole = [...new Set(usersRole)];

    usersRole = await Promise.all(
      usersRole.map(async (roles) => {
        try {
          const result = await OAuthService.getEditData(roleurl, roles);
          if (
            result?.data?.privileges?.includes("Create Budget") ||
            result?.data?.privileges?.includes("PRIVILEGE_CREATEBUD") ||
            result?.data?.privileges?.includes("PRIVILEGES_CREATEBUD")
          ) {
            rolesArray = [...rolesArray, roles];
          }
        } catch (error) { }
      })
    );
    users = users
      .filter((user) => {
        if (
          user?.privileges &&
          (user?.privileges.includes("PRIVILEGE_CREATEBUD") ||
            user?.privileges.includes("PRIVILEGES_CREATEBUD") ||
            user?.privileges.includes("Create Budget"))
        ) {
          return user;
        } else {
          const roleUser = rolesArray.filter((role) => {
            if (user.roles.includes(role)) {
              return role;
            }
          });
          if (roleUser.length > 0) {
            return user;
          }
        }
      })
      .map((user) => {
        const lastName = user?.lastName ? user.lastName : "";
        const middleName = user?.middleName ? user.middleName : "";
        const firstName = user?.firstName ? user.firstName : "";
        const name =
          firstName +
          " " +
          middleName +
          " " +
          lastName +
          " (" +
          user.userName +
          ")";

        return {
          label: name,
          value: user.email,
        };
      });
    setUsers(users);
  };

  const findCompanies = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
    try {
      const partners = await OAuthService.getList(url + `/search/findByCustomerType?customerType=REGULAR`);
      let result = partners?.data?._embedded?.companies
        ?.map((value) => ({ label: `${value.id} - ${value.shortKey} - ${value.countryCode}`, name: `${value.id} - ${value.name}`, id: value.id }));
      setCompanyList(result);
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };
  const filteredCompanies = useMemo(() => {
    if (!searchText) return companyList;

    return companyList.filter((partner) =>
      partner.name.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [searchText, companyList]);
  useEffect(() => {
    findCompanies();
    findUsers();
  }, []);

  const handleUserChange = (value) => {
    const user = value.map((row) => {
      return row.value;
    });
    setPersonName(user);
  };

  const handleSubmit = async () => {
    setCheckSubmit(true);
    let territoryModel = {
      id: territoryId,
      displayName: territoryName,
      areaManager: currentEmail,
    };
    setValidError({
      ...validError,
      territoryName: checkSpecialChar(territoryName),
    });
    const selectedCompany = partner.map((item) => item.id);
    if (partner)
      try {
        if (params.id) {
          if (
            partner.length > 0 &&
            !validError?.territoryName &&
            !validError.territoryId
          ) {
            const res = await OAuthService.updateData(
              url,
              params.id,
              territoryModel
            );
            const companiesApi = `${baseUrl}`;
            if (selectedCompany.length > 0 && companiesApi !== null) {
              // partner update

              await Promise.all(
                selectedCompany.map((companyId) => {
                  const payload = {
                    territory: territoryId,
                  };

                  return OAuthService.updateData(
                    `${companiesApi}/${companyId}`,
                    null,
                    payload,
                  );
                }),
              );
              // Remove partner when click on delete icon

              await Promise.all(
                deSelectedPartner.map((companyId) => {
                  const payload = {
                    territory: "",
                  };

                  return OAuthService.updateData(
                    `${companiesApi}/${companyId}`,
                    null,
                    payload,
                  );
                }),

              );

              setSuccessMsg("Data Updated Successfully");
              setSnackState(true);
              setTimeout(() => {
                navigate("/territories");
              }, 800);
            }
          }
        } else {
          if (
            territoryName &&
            !validError?.territoryName &&
            !validError.territoryId
          ) {
            const data = await OAuthService.addData(url, territoryModel);
            const territoryId = data?.data?.id;
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            const companiesApi = `${baseUrl}`;
            if (selectedCompany.length > 0 && companiesApi) {
              await Promise.all(
                selectedCompany.map((companyId) => {
                  const payload = {
                    territory: territoryId,
                  };

                  return OAuthService.updateData(
                    `${companiesApi}/${companyId}`,
                    null,
                    payload,
                  );
                }),
              );
            }
            setTimeout(() => {
              navigate("/territories");
            }, 800);
          }
        }
      } catch (error) {
        setError(error.message);
        return;
      }
  };

  /**
   * Tab Change
   */
  function handleTabChange(event, value) {
    setTabValue(value);
  }

  const GetTerritory = async () => {
    try {
      const result = await OAuthService.getEditData(url, params.id);
      const territory = result.data;
      setTerritoryId(territory.id);
      setTerritoryName(territory.displayName);
      setCurrentEmail(territory.areaManager);
      const getCompany = await OAuthService.getList(
        `${companyURL}/companiesByTerritory/${territory.id}`
      );
      const companyIds = getCompany?.data || [];

      setPartnerId(companyIds);

      if (companyIds.length > 0) {
        const companyResponses = await Promise.all(
          companyIds.map((id) =>
            OAuthService.getList(`${baseUrl}/${id}`)
          )
        );

        let partner = companyResponses.map((res) => {
          const item = res?.data;
          return {
            id: item.id,
            name: `${item.id} - ${item.name}`,
          };
        });

        partner.sort((a, b) => {
          const nameA = a?.name?.toUpperCase();
          const nameB = b?.name?.toUpperCase();

          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });

        setPartner(partner);

        territory.companyList = partner;
        setEditData(territory);
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };
  const handleAreaManagerEmailChange = (data) => {
    const emails = data.map((row) => {
      return row.value;
    });
    setCurrentEmail(emails);
  };
  useEffect(() => {
    if (params.id) {
      GetTerritory();
      setHideDelete(false);
    }
  }, [params.id]);

  const handleDelete = async () => {
    try {
      if (params.id) {
        await OAuthService.deleteData(url, params.id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
      return;
    }
    setTimeout(() => {
      navigate("/territories");
    }, 800);
  };

  const handleDeleteIcon = async (value) => {
    const data = [value.id];
    setDeSelectedPartner([...deSelectedPartner, value.id]);
    const listCompany = [...companyList, value];
    listCompany.sort(function (a, b) {
      const nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
      const nameB = b?.name?.toUpperCase(); // ignore upper and lowercase

      // sort in an ascending order
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    setCompanyList(listCompany);
    const filterCompany = partner.filter((item) => item !== value);
    filterCompany.length > 0 &&
      filterCompany.sort(function (a, b) {
        const nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
        const nameB = b?.name?.toUpperCase(); // ignore upper and lowercase

        // sort in an ascending order
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    setPartner(filterCompany);
  };

  function dragstart_handler(ev) {
    // Add the target element's id to the data transfer object
    ev.dataTransfer.setData("text/plain", ev.target.id);
    ev.dataTransfer.effectAllowed = "move";
  }
  function dragover_handler(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = "move";
  }
  function drop_handler(ev, box) {
    ev.preventDefault();
    // Get the id of the target and add the moved element to the target's DOM
    const data = ev.dataTransfer.getData("text/plain");
    // ev.target.appendChild(document.getElementById(data));
    const id = data.split("-").pop();

    if (box === "container-right") {
      let formattedcompany = [...partnerId, id];
      setPartnerId(formattedcompany);
      let myobj = companyList.filter((elm) => {
        return elm.id === id;
      });

      {
        myobj[0] && setPartner([...partner, myobj[0]]);
      }
      let newCompanyList = companyList.filter((Elm) => {
        return Elm.id !== id;
      });
      setCompanyList(newCompanyList);
    } else {
      let formattedCompany = [...partnerId, id].filter((item) => item !== id);
      setPartnerId(formattedCompany);
    }
  }

  useEffect(() => {
    if (params.id) {
      removeSelectedCountry();
    }
  }, [params.id, companyList, partner]);

  const removeSelectedCountry = () => {
    const updatedList = companyList.filter(
      (list) => !partner.some((cnt) => list.name === cnt.name)
    );
    setCompanyList(updatedList);
  };

  const handleCancel = () => {
    navigate("/territories");
  };

  const checkUniqueId = async (value) => {
    const result = await OAuthService.getEditData(url, value);

    if (!params.id && result?.data) {
      setValidError({ ...validError, territoryId: "Id already exist" });
    }
  };

  useEffect(() => {
    if (territoryId && territoryName) {
      if (editData) {
        if (
          editData.displayName !== territoryName ||
          JSON.stringify(editData.areaManager) !== JSON.stringify(currentEmail) ||
          JSON.stringify(editData.companyList) !== JSON.stringify(partner)
        ) {
          setSaveDisable(false);
        } else {
          setSaveDisable(true);
        }
      } else {
        setSaveDisable(false);
      }
    } else {
      setSaveDisable(true);
    }
  }, [territoryName, currentEmail, partner]);

  const handleMoveAllRight = () => {
    const companies = partner.concat(companyList).sort(function (a, b) {
      const nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
      const nameB = b?.name?.toUpperCase(); // ignore upper and lowercase

      // sort in an ascending order
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
    setPartner(companies);
    setCompanyList([]);
  };
  const handleMoveSelectedRight = () => {
    const companies = partner.concat(leftChecked).sort(function (a, b) {
      const nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
      const nameB = b?.name?.toUpperCase(); // ignore upper and lowercase

      // sort in an ascending order
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
    setPartner(companies);

    const list = companyList
      .filter((item) => !leftChecked.includes(item))
      .sort(function (a, b) {
        const nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
        const nameB = b?.name?.toUpperCase(); // ignore upper and lowercase

        // sort in an ascending order
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });

    setCompanyList(list);
    setChecked(checked.filter((item) => !leftChecked.includes(item)));
  };
  const handleMoveSelectedLeft = () => {
    const list = companyList.concat(rightChecked).sort(function (a, b) {
      const nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
      const nameB = b?.name?.toUpperCase(); // ignore upper and lowercase

      // sort in an ascending order
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });

    setCompanyList(list);

    const companies = partner
      .filter((item) => !rightChecked.includes(item))
      .sort(function (a, b) {
        const nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
        const nameB = b?.name?.toUpperCase(); // ignore upper and lowercase

        // sort in an ascending order
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });

    setPartner(companies);

    setChecked(checked.filter((item) => !rightChecked.includes(item)));
  };
  useEffect(() => {
    const getUserList = async () => {
      const userData = await OAuthService.getList(userURL);
      setAllUserList(
        userData?.data?._embedded?.users?.map((option) => {
          return { value: option.email, label: option.email };
        })
      );
    };
    getUserList();
  }, []);

  const handleMoveAllLeft = () => {
    const list = companyList.concat(partner).sort(function (a, b) {
      const nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
      const nameB = b?.name?.toUpperCase(); // ignore upper and lowercase

      // sort in an ascending order
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });

    setCompanyList(list);

    setPartner([]);
  };

  return (
    <div className="w-full h-full overflow-scroll">
      <FormPageHeader
        componentName="Territory"
        handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        breadCrumbSeperator=">"
        currentPage={params.id ? "Update Territory" : "Add Territory"}
        parentBreadcrumbData={[
          { pageName: "Territory List", pageLink: "/territories" },
        ]}
        error={error}
        successMsg={successMsg}
        snackState={snackState}
        hideDelete={hideDelete}
        saveDisable={saveDisable}
        handleCancel={handleCancel}
      >
        <Tabs
          value={tabValue}
          textColor="inherit"
          onChange={handleTabChange}
          indicatorColor="secondary"
          sx={{ color: "yellow" }}
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
        >
          <Tab label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
        </Tabs>
      </FormPageHeader>
      <div className="p-16 sm:p-24 max-w-3xl h-full">
        <FormControl
          // ref={formRef}
          className="flex flex-col justify-center"
        >
          <div className={tabValue !== 0 ? "hidden" : ""}>
            <Stack>
              <label>*Territory Id</label>
              <TextField
                className="mb-4"
                type="text"
                name="territoryId"
                value={territoryId}
                required
                disabled={params.id && true}
                error={
                  (checksubmit && !territoryId) || validError.territoryId
                    ? true
                    : false
                }
                helperText={
                  checksubmit && !territoryId
                    ? "This field is required"
                    : validError.territoryId
                }
                onChange={(e) => {
                  setTerritoryId(e.target.value);
                  setValidError({
                    ...validError,
                    territoryId: checkNumber(e.target.value),
                  });
                }}
                onBlur={(e) => checkUniqueId(e.target.value)}
                variant="outlined"
              />
            </Stack>
            <Stack mt={1.5}>
              <label>*Territory Name</label>
              <TextField
                className="mb-4"
                type="text"
                name="territoriName"
                value={territoryName}
                required
                disabled={params.id && true}
                error={
                  (checksubmit && !territoryName) || validError.territoryName
                    ? true
                    : false
                }
                helperText={
                  checksubmit && !territoryName
                    ? "This field is required"
                    : validError.territoryName
                }
                onChange={(e) => {
                  setTerritoryName(e.target.value);
                  setValidError({
                    ...validError,
                    territoryName: checkSpecialChar(e.target.value),
                  });
                }}
                variant="outlined"
              />
            </Stack>
            <Stack mt={1.5}>
              <label>Area Manager Mail Ids</label>

              <Select
                name="currentEmail"
                value={
                  allUserList &&
                  currentEmail &&
                  allUserList.filter((obj) => currentEmail.includes(obj.value))
                }
                onChange={handleAreaManagerEmailChange}
                isMulti
                className="select"
                classNamePrefix="select"
                options={allUserList}
                styles={customStyles()}
              />
            </Stack>
          </div>
        </FormControl>

        <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-between mt-10">
          <div>
            <label>Partners List</label>
            <Box
              sx={{
                width: 400,
                height: 350,
                border: "2px solid grey",
                overflowY: "auto",
              }}
              id="target"
              onDrop={(event) => drop_handler(event, "container-left")}
              onDragOver={(event) => dragover_handler(event)}
            >
              <TextField
                size="small"
                placeholder="Search partners..."
                value={searchText}
                variant="outlined"
                styles={customStyles()}
                onChange={(e) => setSearchText(e.target.value)}
                fullWidth
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  mb: 1,
                  p: 1,
                }}
              />
              {filteredCompanies &&
                filteredCompanies.map((val, key) => {
                  return (
                    <div key={val.id} className="flex">
                      <Checkbox
                        checked={checked.indexOf(val) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": val,
                        }}
                        onChange={handleToggle(val)} // Add onChange event handler
                      />
                      <Chip
                        label={val.name}
                        key={val.id}
                        id={"show-" + val.id}
                        draggable={true}
                        onDragStart={(event) =>
                          dragstart_handler(event, val.id)
                        }
                        color="primary"
                        sx={{ mt: 1, mx: 1, width: "100%", borderRadius: 1 }}
                      />
                    </div>
                  );
                })}
            </Box>
          </div>
          <div className="grid">
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleMoveAllRight}
              disabled={companyList.length === 0}
              aria-label="move all right"
            >
              ≫
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleMoveSelectedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleMoveSelectedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleMoveAllLeft}
              disabled={partner.length === 0}
              aria-label="move all left"
            >
              ≪
            </Button>
          </div>
          <div>
            <label>Selected Partner</label>
            <Box
              sx={{
                width: 400,
                height: 350,
                border: "2px solid grey",
                overflowY: "auto",
              }}
              onDrop={(event) => drop_handler(event, "container-right")}
              onDragOver={(event) => dragover_handler(event)}
            >
              <div>
                {partner &&
                  partner.map((val, key) => {
                    return (
                      <div key={val.id} className="flex">
                        <Checkbox
                          checked={checked.indexOf(val) !== -1}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{
                            "aria-labelledby": val,
                          }}
                          onChange={handleToggle(val)} // Add onChange event handler
                        />
                        <Chip
                          label={val.name}
                          key={val.id}
                          id={"show-" + val.id}
                          // draggable={true}
                          onDragStart={(event) =>
                            dragstart_handler(event, val.id)
                          }
                          color="primary"
                          sx={{
                            mt: 1,
                            mx: 1,
                            width: "100%",
                            borderRadius: 1,
                          }}
                          onDelete={() => handleDeleteIcon(val)}
                        ></Chip>
                      </div>
                    );
                  })}
              </div>
            </Box>
          </div>
        </div>
        {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && partner.length === 0) ? "This field is required" : ''}</Typography> */}
      </div>
    </div>
  );
};

export default TerritoriesForm;
